
import { Component, Vue } from 'vue-property-decorator'
import { CONFIGAPI } from '@/api/config'
import { ConfigModule } from '@/store/modules/config'
import UpdateDialog from '../issueType/updateDialog.vue'
import ConfigLogDialog from '../configLog.vue'
import { getuserCurrentApp } from '@/utils/cookies'

@Component({
  name: 'tutorConfig',
  components: {
    UpdateDialog,
    ConfigLogDialog
  }
})
export default class extends Vue {
  private tableData: any = [] // 问题类型数据
  private expandAll = true // 是否展开全部树形结构
  private updateType = 'add' // 新建/编辑类型 add-新建，edit-编辑
  private currentNode = {} // 当前选择的节点
  private switch: any;

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  mounted() {
    this.getIssueData()
  }

  private async handleSwitchChange(id: number, switchValue: boolean) {
    // 在这个方法中调用后端接口来更新开关状态
    await CONFIGAPI.changeSwithcValue(
      {
        id: id,
        app_id: this.userCurrentApp,
        switch: switchValue ? 1 : 0
        // eslint-disable-next-line @typescript-eslint/no-empty-function
      }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        this.$router.go(10)
      }
    }).catch((error) => {
      console.error('Failed to update switch:', error)
    })
  }

  // 获取问题类型数据
  private async getIssueData() {
    await CONFIGAPI.getIssuesType({ app_id: this.userCurrentApp }).then((res) => {
      if (res.stat === 1) {
        this.tableData = res.data
        this.expandAll = true
      }
    }).catch((error) => {
      console.log('发生错误！', error)
    })
  }

  // 展开/折叠
  private handleExpand() {
    this.expandAll = !this.expandAll
    this.tableData.forEach((i: any) => {
      (this.$refs.tableData as any).toggleRowExpansion(i, this.expandAll)
    })
  }

  // 查看操作日志
  handleShowLog() {
    ConfigModule.ToggleDialogStatus({
      name: 'configLogDialog',
      value: true
    })
  }

  // 新增分类
  private handleCreate() {
    this.updateType = 'add'
    ConfigModule.ToggleDialogStatus({
      name: 'issueTypeAddDialog',
      value: true
    })
  }

  // 编辑分类
  private handleEdit(data: any) {
    this.updateType = 'edit'
    this.currentNode = data
    ConfigModule.ToggleDialogStatus({
      name: 'issueTypeAddDialog',
      value: true
    })
  }

  // 删除分类
  private handleDelete(data: any) {
    this.$confirm(`确定要删除当前问题类型么？【${data.label}】`)
      .then(_ => {
        CONFIGAPI.delIssuesType({
          id: data.id
        }, {
          app_id: this.userCurrentApp
        }).then((res) => {
          if (res.stat === 1) {
            this.$message.success(res.data)
            this.getIssueData()
          }
        }).catch((error) => {
          console.log('发生错误！', error)
        })
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch(_ => {
      })
  }

  // 子组件接口调用成功后
  private handleSuccess() {
    this.getIssueData()
  }
}
